'use client';

import { NextUIProvider } from '@nextui-org/react';

import { QueryClientProvider } from '@/components/app-provider/query-client-provider';
import { SessionProvider } from '@/components/app-provider/session-provider';
import { YMetrikaProvider } from '@/components/app-provider/YM-provider';
import { PdfLinksModal } from '@/components/masterclass/pdf-links-modal';
import { Toaster } from '@/components/ui/toaster';
import { YMetrika } from '@/components/YMetrika';

import ErrorBoundary from './ErrorBoundary';

export const AppProvider = ({
  children,
  params: _params,
}: {
  children: React.ReactNode;
  params: Record<string, string>;
}) => {
  return (
    <>
      <NextUIProvider>
        <QueryClientProvider>
          {/*<ThemeProvider*/}
          {/*  attribute="class"*/}
          {/*  defaultTheme="light"*/}
          {/*  enableSystem*/}
          {/*  disableTransitionOnChange*/}
          {/*>*/}
          <SessionProvider>
            <YMetrikaProvider>
              <YMetrika />
              <ErrorBoundary>
                <Toaster />
                <PdfLinksModal />
                {children}
              </ErrorBoundary>
            </YMetrikaProvider>
          </SessionProvider>
          {/*</ThemeProvider>*/}
        </QueryClientProvider>
      </NextUIProvider>
    </>
  );
};
